import { FeatureFormModel } from "../../app/form";

export class UpdateFeatureRequest {
  title: string;

  constructor(featureForm: FeatureFormModel) {
    this.title = featureForm.title;
  }
}
